<template>
  <div class="bg-card-linear pb-20">
    <nav v-if="!ISLOADING" class="navbar navbar-expand-lg pt-2 main-nav new-header-style">
      <NavBarItems :newDesign="true" />
    </nav>
    <div class="row moreAbout">
      <div class="col">
        <div class="row">
          <div class="col">
            <div>{{$t('myAccount')}}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-auto ms-auto personalAccount_details">
            <div>
              {{ accountName }}
            </div>
          </div>
          <div class="col-auto">
            <a class="share-icon" :href="`https://wa.me/?text=${FRONTEND_URL}/portfolio/${userId}`" target="_blank">
              <i class="fa-solid fa-share-nodes"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="new-content-body-over flex-fill">
    <div class="container">
      <div v-if="hasError"> 
        <errorAlert :alertMessage="message" :errorNumber="errorNumber" /> 
      </div>
      <div v-if="dataLoading" class="text-center">
        <mainloader />
      </div>
      <div v-if="!dataLoading">
        <div class="row profilePage">
          <div class="col-12 col-md-3 pb-5">
            <div class="row">
              <div class="col">
                <div class="card">
                  <div class="card-body">
                    <div class="row justify-content-center">
                      <div class="col-12 text-center">
                        <label>
                          <div class="logo mouse-hand" v-if="user.avatar">
                            <img :src="MEDIA_URL+user.avatar" class="img_Profile" alt="">
                          </div>
                          <i v-else class="fa-solid mouse-hand fa-circle-user logoProfile img_Profile"></i>
                        </label>
                        <div class="py-2 almarai-bold">{{ user.name }}</div>
                        <div class="account-type almarai-bold">{{ accountTypes[user.accountType] }}</div>
                        <div v-if="user.accountType != 'personal' && user.AccountDetail">
                          <small>{{ `${$t('profile.falLicenseNum')}: ${user.AccountDetail.falLicense}` }}</small>
                        </div>
                      </div>
                    </div>
                    <div class="row pt-3 profile-icons">
                      <div v-if="user.accountType != 'personal'" class="col-3">
                        <img src="/assets/images/profile/icon_1.png" class="img-fluid" alt="">
                        <div class="gray-font">{{ $t('profile.aqaryLine1') }}</div>
                        <div class="black-font">{{ $t('profile.aqaryLine2') }}</div>
                      </div>
                      <div v-if="user.accountType != 'personal'" class="col-3">
                        <img src="/assets/images/profile/icon_2.png" class="img-fluid" alt="">
                        <div class="gray-font">{{ $t('profile.priceLine1') }}</div>
                        <div class="black-font">{{ $t('profile.priceLine2') }}</div>
                      </div>
                      <div class="col-3">
                        <img src="/assets/images/profile/icon_3.png" class="img-fluid" alt="">
                        <div class="gray-font">{{ $t('profile.since') }}</div>
                        <div class="black-font">{{ shortDate(user.createdAt) }}</div>
                      </div>
                      <div class="col-3">
                        <img src="/assets/images/profile/icon_4.png" class="img-fluid" alt="">
                        <div class="gray-font">{{ $t('profile.lastSeen') }}</div>
                        <div class="black-font">{{ shortDate(user.lastSeen) }}</div>
                      </div>
                    </div>
                    <div v-if="user.accountType != 'personal' && user.AccountDetail">
                      <div class="row justify-content-center">
                        <div class="col-10"><hr /></div>
                      </div>
                      <div class="row">
                        <div class="col pb-3">
                          <h6>{{ $t('profile.about') }}</h6>
                          <p>{{ user.AccountDetail.bio }}</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 pb-3 text-center">
                          <a :href="`tel:${user.mobile}`" class="d-block green-deep-btn"><i class="fa-solid fa-phone-flip"></i> {{ $t('profile.dial') }}</a>
                        </div>
                        <div class="col-12 pb-3 text-center">
                          <a :href="`https://wa.me/+966${parseInt(user.mobile)}`" class="d-block green-btn"><i class="fa-regular fa-message"></i> {{ $t('profile.whats') }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
    
          <div class="col-12 col-md-9">
            <ul class="nav nav-tabs p-0" role="tablist">
              <li class="nav-item">
                <a class="nav-link active" href="#" data-bs-toggle="tab"
                  data-bs-target="#activeAdsTab"
                  role="tab"
                >{{ $t('profile.activeAds') }} <span v-if="propertiesCount > 0">({{ propertiesCount }})</span></a>
              </li>
              <li v-if="isOwner" class="nav-item">
                <a class="nav-link" href="#" data-bs-toggle="tab"
                  data-bs-target="#underReveiwTab"
                  role="tab"
                >{{ $t('profile.underReview') }} <span v-if="underReviewsCount > 0">({{ underReviewsCount }})</span></a>
              </li>
            </ul>

            <div class="tab-content border p-3" id="myTabContent">
              <div class="tab-pane fade show active" id="activeAdsTab" role="tabpanel">
                <div v-if="propertyLoader" class="text-center">
                  <mainloader />
                </div>
                <div v-if="!propertyLoader">
                  <div class="row">
                    <div class="col-12 col-sm-4 pb-4" v-for="(row,index) in propertiesList" :key="index">
                      <router-link :to="'/propertydetails/'+row.id+'?a=1&propertyType=property'">
                        <div class="card card-border m-auto">
                          <div class="card-body padding-8">
                            <div class="row position-Abso pt-2">
                              <div class="col-auto tag-style">
                                <span class="">{{ row.PropertyType.name }}</span>
                              </div>
                              <div class="col-auto tag-style mx-2">
                                <span class="">{{statusChoices[row.status]}}</span>
                              </div>
                              <div class="col-auto tag-style">
                                <span class="">{{(row.purpose == 'for_rent') ? $t('rent') : (row.purpose == 'for_sale') ? $t('sale')  : $t('investment') }}</span>
                              </div>
                            </div>
                            <swiper v-if="row.mediaFiles.length" class="text-center" 
                              :modules="modules"
                              :autoplay="{ delay: 2500,disableOnInteraction: false,}" 
                              :pagination="{ clickable: true }" :navigation="false"
                            >
                              <swiper-slide v-for="(slide, indx) in row.mediaFiles" :key="indx">
                                <img :src="MEDIA_URL+slide.thumbnail" alt="Slide Image" class="w-100 br-radius" />
                              </swiper-slide>
                            </swiper>
                            <div v-else>
                              <img src="/assets/images/defaultImage.jpg" class="w-100 br-radius" alt="">
                            </div>
                            <div class="almarai-regular py-1 space">{{ row.title }}</div>
                            <div class="d-flex">
                              <i class="fa-solid fa-location-dot gray-color"></i>
                              <div class="gray-color fonttext-14 mx-2"> {{ row.City.name }} </div>
                              <span class="gray-color fonttext-14"> {{ row.Neighborhood.name }} </span>
                            </div>
                            <hr class="border-color-w">
                            <div class="row end-card">
                              <div class="col">
                                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                                <span class="green-color-F">{{ row.price }}</span>
                                <!-- <span class="mx-1 green-color-F">{{$t('currency')}}</span> -->
                              </div>
                              <div v-if="row.roomsCount" class="col-auto content-center">
                                <img :src="MEDIA_URL+icons.roomsCount.path" class="max-width-28" alt="">
                                <span class="numbers"> {{ row.roomsCount }} </span>
                              </div>
                              <div v-if="row.bathrooms" class="col-auto border_Icons">
                                <img :src="MEDIA_URL+icons.bathrooms.path" class="max-width-28" alt="">
                                <span class="numbers"> {{ row.bathrooms }} </span>
                              </div>
                              <div v-if="!row.roomsCount && !row.bathrooms && row.area" class="col-auto border_Icons">
                                <img :src="MEDIA_URL+icons.area.path" class="max-width-28" alt="">
                                <span class="numbers"> {{ row.area }} </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
  
                  <div class="row pt-5">
                    <div class="col">
                      <nav aria-label="Page navigation example">
                        <ul class="pagination justify-content-center mouse-hand">
                          <li class="page-item pagination-padding page-link br-radius4" v-if="currentPage > 1"  @click.prevent="prevPage">
                            <i class="fa-solid fa-circle-right orange-color mx-2"></i>
                            <span>{{$t('prev')}}</span>
                          </li>
                          <li class="page-item pagination-style">{{currentPage}}</li>
                          <li class="page-item page-link pagination-padding br-radius4" v-if="hasNext"  @click.prevent="nextPage">
                            <span class="mx-2">{{$t('next')}}</span>
                            <i class="fa-solid fa-circle-left orange-color"></i>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="isOwner" class="tab-pane fade" id="underReveiwTab" role="tabpanel">
                <div class="row">
                  <div class="col-12 col-sm-4 pb-4" v-for="(row,index) in underReview" :key="index">
                    <router-link :to="'/propertydetails/'+row.id+'?m=1&a=1&propertyType=property'">
                      <div class="card card-border m-auto">
                        <div class="card-body padding-8">
                          <div class="row position-Abso pt-2">
                            <div class="col-auto tag-style">
                              <span class="">{{ row.PropertyType.name }}</span>
                            </div>
                            <div class="col-auto tag-style mx-2">
                              <span class="">{{statusChoices[row.status]}}</span>
                            </div>
                            <div class="col-auto tag-style">
                              <span class="">{{(row.purpose == 'for_rent') ? $t('rent') : (row.purpose == 'for_sale') ? $t('sale')  : $t('investment') }}</span>
                            </div>
                          </div>
                          <swiper v-if="row.mediaFiles.length" class="text-center" 
                            :modules="modules"
                            :autoplay="{ delay: 2500,disableOnInteraction: false,}" 
                            :pagination="{ clickable: true }" :navigation="false"
                          >
                            <swiper-slide v-for="(slide, indx) in row.mediaFiles" :key="indx">
                              <img :src="MEDIA_URL+slide.thumbnail" alt="Slide Image" class="w-100 br-radius" />
                            </swiper-slide>
                          </swiper>
                          <div v-else>
                            <img src="/assets/images/defaultImage.jpg" class="w-100 br-radius" alt="">
                          </div>
                          <div class="almarai-regular py-1 space">{{ row.title }}</div>
                          <div class="d-flex">
                            <i class="fa-solid fa-location-dot gray-color"></i>
                            <div class="gray-color fonttext-14 mx-2"> {{ row.City.name }} </div>
                            <span class="gray-color fonttext-14"> {{ row.Neighborhood.name }} </span>
                          </div>
                          <hr class="border-color-w">
                          <div class="row end-card">
                            <div class="col">
                              <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                              <span class="green-color-F">{{ row.price }}</span>
                              <!-- <span class="mx-1 green-color-F">{{$t('currency')}}</span> -->
                            </div>
                            <div v-if="row.roomsCount" class="col-auto content-center">
                              <img :src="MEDIA_URL+icons.roomsCount.path" class="max-width-28" alt="">
                              <span class="numbers"> {{ row.roomsCount }} </span>
                            </div>
                            <div v-if="row.bathrooms" class="col-auto border_Icons">
                              <img :src="MEDIA_URL+icons.bathrooms.path" class="max-width-28" alt="">
                              <span class="numbers"> {{ row.bathrooms }} </span>
                            </div>
                            <div v-if="!row.roomsCount && !row.bathrooms && row.area" class="col-auto border_Icons">
                              <img :src="MEDIA_URL+icons.area.path" class="max-width-28" alt="">
                              <span class="numbers"> {{ row.area }} </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import NavBarItems from '@/components/navbar_items.vue';
import { shortDate } from '@/helpers/tools';
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Pagination, Navigation, Autoplay } from "swiper/modules";

export default {
  name: "PublicProfile",
  setup(){
    return{
      modules: [Autoplay, Navigation, Pagination ],
    }
  },
  data() {
    return {
      userId: this.$route.params.id,
      hasError: false,
      message: "",
      errorNumber: 0,
      dataLoading: true,
      user: null,
      propertiesList: [],
      underReview: [],
      accountTypes: {},
      accountName: this.$t('myPersonal'),
      isOwner: false,
      propertiesCount: 0, 
      underReviewsCount: 0,
      statusChoices: {},
      icons: {},
      hasNext: false,
      currentPage: 1,
      propertyLoader: false,
    };
  },
  components: {
    NavBarItems, Swiper, SwiperSlide
  },
  computed: {
    ...mapGetters(['MEDIA_URL','GET_USER_DATA','GET_USER','ISLOADING', 'FRONTEND_URL']),
  },

  methods: {
    shortDate,
    getProfile() {
      this.hasError = false;
      this.$http.get(`/api/accountDetails/profile/${this.userId}?page=${this.currentPage}`).then(({data}) => {
        this.user = data.user;
        this.propertiesList = data.propertiesList ?? [];
        this.underReview = data.underReview ?? [];
        this.accountTypes = data.accountTypes ?? {};
        this.isOwner = data.isOwner ?? false;
        this.propertiesCount = data.propertiesCount ?? 0;
        this.underReviewsCount = data.underReviewsCount ?? 0;
        this.statusChoices = data.statusChoices ?? {};
        this.icons = data.countedIcons ?? {};
        if(this.user.accountType == 'company' && this.user.AccountDetail){
          this.accountName = this.user.AccountDetail.companyName;
        }
        if(this.propertiesList.length >= 30)
          this.hasNext = true;
        this.dataLoading = false;
        this.propertyLoader = false;
        window.scrollTo({top:0, behavior: 'smooth'});
      }).catch((err) => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({top:0, behavior: 'smooth'});
      });
    },
    prevPage(){
      this.currentPage -= 1;
      this.propertyLoader = true;
      this.getProfile();
    },
    nextPage(){
      this.currentPage += 1;
      this.propertyLoader = true;
      this.getProfile();
    },
  },
  created() {
    this.getProfile();
    this.userLang = localStorage.getItem('lang') ??  'ar';
    window.scrollTo({top:0, behavior: 'smooth'});
  },
};
</script>
<style scoped>
.account-type {
  color: #AA9359;
}
.profile-icons {
  justify-content: center;
  font-weight: bold;
  font-size: 10px;
  text-align: center;
}
.share-icon {
  color: #ffffff;
  font-size: 26px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  overflow: hidden;
  display: inline-block;
  line-height: 46px;
  vertical-align: middle;
  text-align: center;
}
.share-icon i, .share-icon svg {
  vertical-align: middle;
}
</style>